import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import { useFormik, Form, FormikProvider } from 'formik';
// material
import { Stack, Card, TextField } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
// utils
import fakeRequest from '../../../../utils/fakeRequest';
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import apiUser from '../../../../api/user';
// ----------------------------------------------------------------------

export default function SettingChangePassword({ onClose }) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const ChangePassWordSchema = Yup.object().shape({
    oldPassword: Yup.string().required(t('old_password_is_required')),
    newPassword: Yup.string().min(6, t('password_must_be_at_least_6_characters')).required(t('new_password_is_required')),
    confirmNewPassword: Yup.string().oneOf([Yup.ref('newPassword'), null], t('passwords_must_match'))
  });

  const formik = useFormik({
    initialValues: {

    },
    validationSchema: ChangePassWordSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const res = await apiUser.change_password(values);
        if (res.status == 200) {
          enqueueSnackbar("Cập nhật thông tin thành công !", { variant: 'success' });
          resetFormChangePW();
          onClose();
        }
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
      }
    }
  });
  const resetFormChangePW = () => {
    formik.setFieldValue('oldPassword', '');
    formik.setFieldValue('newPassword', '');
    formik.setFieldValue('confirmNewPassword', '');
  };

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <Card sx={{ p: 3 }}>
      <FormikProvider value={formik}>
        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
          <Stack spacing={3} alignItems="center">
            <TextField
              {...getFieldProps('oldPassword')}
              fullWidth
              autoComplete="on"
              type="password"
              label={t('old_password')}
              error={Boolean(touched.oldPassword && errors.oldPassword)}
              helperText={touched.oldPassword && errors.oldPassword}
            />

            <TextField
              {...getFieldProps('newPassword')}
              fullWidth
              autoComplete="on"
              type="password"
              label={t('new_password')}
              error={Boolean(touched.newPassword && errors.newPassword)}
              helperText={(touched.newPassword && errors.newPassword) || t('password_must_be_minimum_6+')}
            />

            <TextField
              {...getFieldProps('confirmNewPassword')}
              fullWidth
              autoComplete="on"
              type="password"
              label={t('confirm_new_password')}
              error={Boolean(touched.confirmNewPassword && errors.confirmNewPassword)}
              helperText={touched.confirmNewPassword && errors.confirmNewPassword}
            />

            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <LoadingButton startIcon={<Icon icon="codicon:save-as" />} type="submit" variant="contained" color="secondary" loading={isSubmitting}>
                Cập nhật
              </LoadingButton>
              <LoadingButton startIcon={<Icon icon="pajamas:cancel" />} variant="contained" color="error" onClick={() => onClose()}>
                Đóng
              </LoadingButton>
            </Stack>
          </Stack>
        </Form>
      </FormikProvider>
    </Card>
  );
}
